import { get, post, put } from 'src/api/index';
import {
  AccessTokenInput,
  AccessTokenOutput,
  AutoLogin,
  LoginInput,
  LoginOutput,
  RegisterInput,
  RegisterOutput,
  VerifyCellphoneOutput,
  VerifyEmailOutput
} from 'src/types/auth';

export const login = async (body: LoginInput) =>
  await post<LoginOutput>('/login', body);

export const auto_login = async (body: AutoLogin) =>
  await post<{
    result: {
      accessToken: string;
      refreshToken: string;
      tokenType: string;
    };
  }>('/auto-login', body);

export const access_token = async (body: AccessTokenInput) =>
  await post<AccessTokenOutput>('/access-token', body);

export const request_email = async (body: { email: string }) =>
  await post<{ success: boolean }>('/request-email', body);

export const verify_email = async (body: { email: string; code: string }) =>
  await post<VerifyEmailOutput>('/verify-email', body);

export const verify_cellphone = async (body: { iamuid: string }) =>
  await post<VerifyCellphoneOutput>('/verify-cellphone', body);

export const register = async (body: RegisterInput) =>
  await post<RegisterOutput>('/join', body);

export const with_draw = async () =>
  await put<{ success: boolean }>('/withdraw');

export const post_statistics = async (params: { friendsId: string }) =>
  await get('/statistics/url', { params });
